<template>
  <div class="card maadi-dark-card m-1">
    <div class="card-header d-flex">
      <div>
        {{ rankedStatistic.title }}
        <br>
        <span style="font-weight: 300; font-size: 0.8em;">{{ rankedStatistic.description }}</span>
      </div>
      <div class="ml-auto d-flex align-items-center">
        <a class="pl-2" v-b-modal="'modal_' + rankedStatistic.type" style="cursor: pointer;"><i class="fas fa-list"></i></a>
      </div>
    </div>
    <div class="card-body" >
      <div class="d-flex">
        <div class="flex-fill m-1 p-2">
          <div class="stat-number text-center">
            {{ rankedStatistic.median | commas }}
          </div>
          <div class="stat-descriptor text-center">
            MEDIAN
          </div>
        </div>
        <div class="flex-fill m-1 p-2">
          <div class="stat-number text-center">
            {{ rankedStatistic.sum | commas}}
          </div>
          <div class="stat-descriptor text-center">
            COUNT
          </div>
        </div>
      </div>
      <div v-if="accountIDIsSet" style="border: 1px solid #ddd; background: #eee; color: #000">
        <div v-if="statisticOfAccountID.count > 0"  class="p-2">
          <div class="text-center">
            {{ statisticOfAccountID.organization_name }}
          </div>
          <div class="d-flex">
            <div class="flex-fill m-1 p-2">
              <div class="stat-number text-center">
                {{ statisticOfAccountID.count | commas }}
              </div>
              <div class="stat-descriptor text-center">
                TOTAL
              </div>
            </div>
            <div class="flex-fill m-1 p-2">
              <div class="stat-number text-center">
                {{ statisticOfAccountID.rank_name }}
              </div>
              <div class="stat-descriptor text-center">
                RANK
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          NO STATISTICS DURING THIS TIME PERIOD
        </div>
      </div>
      <b-modal  :id="'modal_' + rankedStatistic.type" :title="rankedStatistic.title" scrollable ok-only hide-footer>
        <b-table sort-by="ranking" striped hover :items="rankedStatistic.statistics" :fields="modalFields" :tbody-tr-class="highlightedRow">
          <template #cell(count)="data">
            {{ data.value | commas }}
          </template>
        </b-table>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['rankedStatistic', 'accountID'],
  computed: {
    accountIDIsSet: function () {
      return this.accountID !== null && this.accountID !== undefined
    },
    statisticOfAccountID: function () {
      const statisticObject = this.rankedStatistic.statistics.filter((x) => x.account_id === this.accountID)
      if (statisticObject.length > 0) {
        return statisticObject[0]
      }
      return {
        count: 0
      }
    }
  },
  methods: {
    highlightedRow (item, type) {
      if (!item) return
      if (item.account_id === parseInt(this.accountID)) {
        return 'table-success'
      }
    }
  },
  data: function () {
    return {
      modalFields: [
        {key: 'rank_name', label: 'Rank', sortable: false},
        {key: 'organization_name', label: 'Account', sortable: true},
        {key: 'count', label: 'Count', sortable: true}
      ]
    }
  }
}
</script>

<style scoped>
  .stat-holder {
    border: solid 1px #EEE;
  }
  .stat-number {
    font-size: 2.0em;
  }

</style>



// WEBPACK FOOTER //
// src/components/organizations/rankings/RankedStatistic.vue